import { forwardRef as T } from "react";
import { useThemeUI as V } from "theme-ui";
import * as W from "@radix-ui/react-dialog";
import * as j from "@radix-ui/react-visually-hidden";
import { SwipeIndicatorIcon as N } from "@material-bank/mb-icons";
import { Stack as s } from "../../../Stack/Stack.js";
import { DialogHeader as v } from "../DialogHeader/DialogHeader.js";
import { jsxs as i, jsx as r } from "theme-ui/jsx-runtime";
const E = T((a, c) => {
  const {
    children: d,
    dialogVariant: t,
    titleVariant: m,
    onBackButtonClick: h,
    title: o,
    swipeHandlers: f,
    displayCloseButton: p,
    headerLeftActions: x,
    headerRightActions: S,
    headerBackIcon: g,
    headerCloseIcon: u,
    onPointerDownOutside: e,
    displayBottomSheetIndicator: C = !0,
    htmlTitle: A,
    contentContainerSx: w,
    headerContainerSx: I,
    headerSx: b,
    titleSx: B,
    titleWithLeftActionsSx: D,
    headerActionsContainerSx: R,
    headerLeftActionsSx: k,
    headerRightActionsSx: P,
    ...y
  } = a, {
    theme: H
  } = V(), L = (n) => {
    const l = n.composedPath()[0];
    e == null || e(n), l instanceof HTMLElement && l.localName === "com-1password-button" && n.preventDefault();
  };
  return /* @__PURE__ */ i(W.Content, {
    ref: c,
    title: A,
    ...y,
    sx: {
      ...H.dialogContent[t],
      ...a.sx
    },
    onPointerDownOutside: L,
    children: [/* @__PURE__ */ i(s, {
      sx: {
        flex: 1,
        px: [4, 8],
        pb: [4, 8],
        overflowY: "auto",
        overflowX: "hidden",
        ...w
      },
      children: [o && /* @__PURE__ */ r(j.Root, {
        children: o
      }), d]
    }), /* @__PURE__ */ i(s, {
      sx: {
        alignItems: "center",
        rowGap: [6, null, 0],
        ...t === "modal" && {
          mb: [2, 6]
        },
        ...t === "fullScreenRightSide" && {
          mb: [5, 7]
        },
        ...(t === "bottomSheet" || t === "modalBottomSheet") && {
          mb: 5
        },
        ...I
      },
      ...f,
      children: [(t === "bottomSheet" || t === "modalBottomSheet") && C && /* @__PURE__ */ r(N, {}), /* @__PURE__ */ r(v, {
        displayCloseButton: p,
        dialogVariant: t,
        leftActions: x,
        rightActions: S,
        backIcon: g,
        closeIcon: u,
        titleVariant: m,
        onBackButtonClick: h,
        sx: b,
        titleSx: B,
        titleWithLeftActionsSx: D,
        actionsContainerSx: R,
        leftActionsSx: k,
        rightActionsSx: P,
        children: o
      })]
    })]
  });
});
E.displayName = "DialogContentWrapper";
export {
  E as DialogContentWrapper
};
